import { ExpenseSummary } from "@/components/ExpenseSummary";
import { motion } from "framer-motion";
import { Expense } from "@/types/expense";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Share2 } from "lucide-react";
import { toast } from "sonner";
import { ScrollArea } from "@/components/ui/scroll-area";

interface AnalyticsTabProps {
  expenses: Expense[];
  recentExpenses: { id: string }[];
  tripParticipants: string[];
}

export const AnalyticsTab = ({ expenses, recentExpenses, tripParticipants }: AnalyticsTabProps) => {
  const originalRecentExpenses = recentExpenses.filter(({ id }) => {
    const expense = expenses.find(e => e.id === id);
    return expense && !expense.description.includes('(Split');
  });

  const handleExportData = () => {
    // Implementation for exporting data
    toast.success("Exporting data...");
  };

  const handleShareInsights = () => {
    // Implementation for sharing insights
    toast.success("Preparing to share insights...");
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-8"
    >
      <div className="flex flex-wrap gap-4 justify-end">
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={handleExportData}
        >
          <Download className="h-4 w-4" />
          Export Data
        </Button>
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={handleShareInsights}
        >
          <Share2 className="h-4 w-4" />
          Share Insights
        </Button>
      </div>

      <ScrollArea className="h-[calc(100vh-16rem)]">
        <ExpenseSummary expenses={expenses} />
        
        {originalRecentExpenses.length > 0 && (
          <Card className="mt-8 p-6 bg-white shadow-sm">
            <h3 className="text-lg font-semibold mb-4">Recent Activity</h3>
            <div className="space-y-3">
              {originalRecentExpenses.map(({ id }) => {
                const expense = expenses.find(e => e.id === id);
                if (!expense) return null;
                return (
                  <motion.div
                    key={id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    className="flex justify-between items-center p-3 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
                  >
                    <span className="text-sm text-gray-700">{expense.description}</span>
                    <span className="text-sm font-medium text-primary">
                      ₹{Number(expense.amount).toFixed(2)}
                    </span>
                  </motion.div>
                );
              })}
            </div>
          </Card>
        )}
      </ScrollArea>
    </motion.div>
  );
};